import { t } from "./i18n";
import { SigningResource } from "./types";

export interface PendingSigning {
  id?: string;
  name: string;
  stage: "creating" | "uploading" | "recipients" | "sending";
}

export function recoveryKey(tenant: string, email: string): string {
  return `krebitSign.pendingSigning.${tenant}.${email.toLowerCase()}`;
}

export function loadPendingSigning(key: string): PendingSigning | undefined {
  const raw = localStorage.getItem(key);
  if (!raw) {
    return undefined;
  }
  const value = JSON.parse(raw) as PendingSigning;
  if (
    typeof value.name !== "string" ||
    ["creating", "uploading", "recipients", "sending"].indexOf(value.stage) < 0 ||
    (value.id !== undefined && typeof value.id !== "string")
  ) {
    throw new Error(t("recoveryStatusUnknown"));
  }
  return value;
}

export function savePendingSigning(key: string, value: PendingSigning | undefined): void {
  try {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.removeItem(key);
    }
  } catch (_error) {
    throw new Error(t("recoveryStorageFailure"));
  }
}

export function getRecoveryStatus(signing: SigningResource): "draft" | "sent" | "cancelled" | "unknown" {
  if (signing.cancelled_at) {
    return "cancelled";
  }
  if (signing.is_draft === true) {
    return "draft";
  }
  return signing.is_draft === false ? "sent" : "unknown";
}
